import React from 'react';
import {Link} from "react-router-dom";

import {observer} from 'mobx-react';
import {withStore} from "../../hocs";
import {EnumUserType} from "../../enum/EnumUserType";
import {adminPanelUrl} from "../../constants/adminPanelPath";


// @ts-ignore
@withStore
@observer
export class AdminTop extends React.Component {
    render() {

        // @ts-ignore
        const {store} = this.props;
        const {user, goodMode, changeGoodMode, myUser} = store?.mainStore;
        const {onLoginRoot} = store?.authStore;
        let userName = '';
        let userParentName = '';
        let userParentId = 0;
        if (user) {
            userName = user.email;
            userParentName = user.parentEmail;
            userParentId = parseInt(user.parentId);
        }
        let isAdmin = false;
        if (user && (user?.type === EnumUserType.adminAuth || user?.type === EnumUserType.root)) {
            isAdmin = true;
        }

        let isAdminPanel1 = goodMode || userParentId || user?.type === EnumUserType.adminAuth || user?.type === EnumUserType.root;

        if (isAdminPanel1 || myUser) {
            return (
                <>
                    {userName === 'dev@sellwin.by' ? null : 
                     <div className="light-white">
                     <div className="container ">
                         <div className="admins-panel">
                             {isAdmin ?
                                 <div><Link className={'little-phonetext'} to={adminPanelUrl()}> Администрирование </Link>
                                 </div> : <span>{null}</span>}
                             {goodMode ?
                                 <>
                                 <span className="little-phonetext"
                                       onClick={() => changeGoodMode()}>REQUEST {goodMode}</span>
                                     {!user ? <span className="little-phonetext cursor"
                                                    onClick={() => store.mainStore.SetPasswordDemo()}>DEMO AUTH</span> : null}
                                 </> : null}
                             {userParentId && !isAdmin && userParentName !== userName ?
                                 <ul className="breadcrumbs__list">
                                     <li className="breadcrumbs__item">
                                     <span className="breadcrumbs__item-text cursor"
                                           onClick={() => onLoginRoot(userParentId)}>{userParentName}</span>
                                     </li>
                                     <li className="breadcrumbs__item">
                                         <span className="breadcrumbs__item-text-active">{userName}</span>
                                     </li>
                                 </ul> : <span className="little-phonetext">{userName}</span>}
                             {myUser ?
                                 <ul className="breadcrumbs__list">

                                     <li className="breadcrumbs__item">
                                     <span className="breadcrumbs__item-text cursor"
                                           onClick={() => onLoginRoot(myUser.id)}>{myUser.siteId === 1 ? 'авторизоваться для b2b закупок' : 'авторизоваться как сотрудник'}</span>
                                     </li>
                                 </ul> : null

                             }
                         </div>
                     </div>
                 </div>
                    }
                   
                </>
            );
        }
        return null;
    }
}


